import config from '../config'

export default class ShareUtils {
  static generatePsw () {
    let letters = 'abcdefghijklmnpqrstuvwxyz'
    let numbers = '123456789'
    let pickedLetters = 0
    let pickedNumbers = 0
    let psw = ''
    while (psw.length < 4) {
      if (pickedLetters >= 2) {
        psw = psw + numbers.charAt(Math.floor(Math.random() * 9))
        pickedNumbers++
      } else if (pickedNumbers >= 2) {
        psw = psw + letters.charAt(Math.floor(Math.random() * 25))
        pickedLetters++
      } else {
        if (Math.random() < 0.5) {
          psw = psw + letters.charAt(Math.floor(Math.random() * 25))
          pickedLetters++
        } else {
          psw = psw + numbers.charAt(Math.floor(Math.random() * 9))
          pickedNumbers++
        }
      }
    }
    return psw
  }

  static getFixedWatermark (item) {
    const loginUser = config.user_info || {}
    if (item.is_share_watermark_customize_content_switch) {
      if (item.is_share_watermark_creator_account) {
        return (loginUser.login ? loginUser.login : '') + ' + ' + item.share_watermark_customize_content
      } else {
        return item.share_watermark_customize_content
      }
    } else {
      if (item.is_share_watermark_creator_account) {
        return (loginUser.login ? loginUser.login : '')
      } else {
        return ''
      }
    }
  }

  /**
   * 用于判断两个字符串是否相等，undefine 等于 ‘’
   */
  static stringEquals (str1, str2) {
    if (!str1) {
      return !str2 || str2 === ''
    } else if (!str2) {
      return !str1 || str1 === ''
    } else {
      return str1 === str2
    }
  }
}
